module.exports = __webpack_public_path__ + "img/frame1.49aa74bf.jpg";